import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

export default class ModalConfirmacion extends Component {
  render() {
    return (
      <Modal {...this.props} centered>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">Ventana de confirmación</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.texto}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              this.props.deleteFunction();
              this.props.handleButtonShow();
            }}
            variant="outline-danger"
          >
            Eliminar
          </Button>
          <Button onClick={this.props.handleButtonShow} variant="outline-primary">
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
